import React, { useState, useEffect, useRef } from "react";

// material ui
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormGroup from "@material-ui/core/FormGroup";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";

import useStyles from "./styles";

import chunk from "lodash/chunk";

import validation from "../validation";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";

import InfoButton from "../../../../../components/InfoButton";
function SubFormNumber21New({
  id,
  setValue,
  saveValue,
  saveChangeValue,
  value,
  form,
  wilayah,
  keluarga,
  handleBackSub,
  navigationMode,
  isSingle,
  setIsSingle,
  subformIndex,
  direction,
  backRadio,
  isSubmitting,
  pk,
}) {
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const classes = useStyles();
  const [error, setError] = useState({});

  const [berlaku, setBerlaku] = useState(false);

  const [jawaban, setJawaban] = useState(value.jawaban || "");
  const [jawabanA, setjawabanA] = useState(value.jawabanA || "");
  const [jwbLain, setJwbLain] = useState(value.jawaban_lainnya || "");
  const [kondisi, setKondisi] = useState(value.kondisi || 0);

  useEffect(() => {
    setError({});
  }, []);

  useEffect(() => {
    let valIndex = 0;
    if (
      wilayah.status_draft == 1 &&
      wilayah.pos_draft == 3 &&
      wilayah.subformIndex !== undefined
    ) {
      valIndex = wilayah.subformIndex;
      // if (value.jawaban !== undefined) {
      //   // handleSubmit(null)
      //   console.log("next nya neeeh ::: ");
      //   // console.log("subformIndex nya neeeh : " , subformIndex)
      // }
    }

    // console.log(direction, "DIRECTION");
    if (form.dependencies.length <= 0) {
      setBerlaku(true);
    } else {
      const valuesKel = Object.values(keluarga);
      const cekberlaku = form.dependencies.some((dep) => {
        return validation[dep](valuesKel);
      });

      let normalizeValue;
      // if (!cekberlaku) {
      //   setValue({ target: { name: "jawaban", value: "3" } });

      //   if (direction.navigate === "right") {
      //     console.log("radio : run right function");
      //     if (value.jawaban === undefined || value.jawaban === "3") {
      //       console.log(
      //         "radio : run right undefined | value jawaban = 3 function"
      //       );
      //       normalizeValue = {
      //         Pertanyaan: pertanyaan,
      //         Jawab_Pilih: "3",
      //         Jawaban_H1: value.kondisi || 0,
      //         Jawaban_H2: 0,
      //         No_Pertanyaan: parseInt(form.no),
      //         Lainnya: value.jawaban_lainnya || "",
      //       };

      //       if (value._rev) {
      //         normalizeValue._rev = value._rev;
      //       }

      //       saveValue(normalizeValue);
      //     }
      //   } else if (direction.navigate === "left") {
      //     if (value.jawaban === "3") {
      //       backRadio(cekberlaku);
      //     }
      //   }
      // }

      setBerlaku(true);
    }

    // console.log("direction : ", direction)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, form]);

  const { pertanyaan, definisi_operasional } = form;

  const handleChange = (e) => {
    if (e.target.type === "number") {
      if (parseInt(e.target.value) < 0) return false;

      // if (e.target.name === "kondisi" && ![0, 1].includes(parseInt(e.target.value))) {
      //     return false;
      // }
    }

    setValue(e);

    setError({
      ...error,
      [e.target.name]: "",
    });

    switch (e.target.name) {
      case "jawaban":
        setJawaban(e.target.value);
        setjawabanA("");
        setError({
          ...error,
          jawabanA: "",
        });
        break;
      default:
        break;
    }
    // setSomethingChange(true)
  };

  useEffect(() => {
    let normalizeValue = {
      Pertanyaan: pertanyaan,
      Jawab_Pilih: jawaban,
      Jawaban_H1: kondisi || 0,
      Jawaban_H2: 0,
      No_Pertanyaan: parseInt(form.no),
      Lainnya: jwbLain || "",
      Pertanyaan2:
        "Jika 21.1 dijawab kode 4, 5, 6, 7, atau 8, berapa jarak ke tempat penampungan kotoran/tinja terdekat?",
      Jawab_Pilih2: jawabanA,
      No_Pertanyaan2: "21.2",
      // No_Pertanyaan2: '6.1'
    };
    // console.log("save change number_21 => ", normalizeValue);

    if (value._rev) {
      normalizeValue._rev = value._rev;
    }
    //console.log("save change radio => ", normalizeValue)
    saveChangeValue(normalizeValue);
  }, [jawaban, jawabanA, jwbLain, kondisi]);

  const validate = () => {
    // console.log(normalizeValue, "val jawabanA");
    let newError = {};

    if (!value.jawaban) {
      newError.jawaban = "Wajib diisi";
    }

    // if (+value.jawaban === 1 && (!jawabanA || jawabanA.length === 0)) {
    //   newError.jawabanA = "Wajib dipilih minimal satu";
    // }
    if (
      (+value.jawaban === 4 ||
        +value.jawaban === 5 ||
        +value.jawaban === 6 ||
        +value.jawaban === 7 ||
        +value.jawaban === 8) &&
      !jawabanA
    ) {
      newError.jawabanA = "Wajib dipilih salah satu";
    }

    return newError;
  };

  const handleSubmit = (e) => {
    if (e !== null) {
      e.preventDefault();
    }

    const findErrors = validate();
    const errorValues = Object.values(findErrors);

    if (errorValues.length > 0 && errorValues.some((err) => err !== "")) {
      setError(findErrors);
    } else {
      // const normalizeValue = {
      //     pertanyaan,
      //     jawaban_1: value.jawaban,
      //     jawaban_2: value.jawaban_lainnya
      // }

      let normalizeValue = {
        Pertanyaan: pertanyaan,
        Jawab_Pilih: value.jawaban,
        Jawaban_H1: value.kondisi || 0,
        Jawaban_H2: 0,
        No_Pertanyaan: parseInt(form.no),
        Lainnya: value.jawaban_lainnya || "",
        Pertanyaan2:
          "Jika 21.1 dijawab kode 4, 5, 6, 7, atau 8, berapa jarak ke tempat penampungan kotoran/tinja terdekat?",
        Jawab_Pilih2: value.jawabanA,
        No_Pertanyaan2: "21.2",
      };
      if (value._rev) {
        normalizeValue._rev = value._rev;
      }
      saveValue(normalizeValue);
    }
  };
  //console.log('here')
  const isChecked = (option_no) => {
    // const selected = jawabanA || [];
    // return selected.indexOf(option_no) !== -1;
    return jawabanA == option_no;
  };

  // const handleChangeRadio = (option_no) => (e) => {
  //   // const selected = jawabanA || [];
  //   const selectedValue = e.target.value;

  //   // const selectedIndex = selected.indexOf(option_no);
  //   // let newSelected = [];

  //   // if (selectedIndex === -1) {
  //   //   newSelected = newSelected.concat(selected, option_no);
  //   // } else if (selectedIndex === 0) {
  //   //   newSelected = newSelected.concat(selected.slice(1));
  //   // } else if (selectedIndex === selected.length - 1) {
  //   //   newSelected = newSelected.concat(selected.slice(0, -1));
  //   // } else if (selectedIndex > 0) {
  //   //   newSelected = newSelected.concat(
  //   //     selected.slice(0, selectedIndex),
  //   //     selected.slice(selectedIndex + 1)
  //   //   );
  //   // }

  //   setValue({ target: { name: "jawabanA", value: selectedValue } });

  //   setjawabanA(selectedValue);

  //   setError({
  //     ...error,
  //     jawabanA: "",
  //   });
  //   // setSomethingChange(true)
  // };

  const handleChangeRadio = (e) => {
    const selectedValue = e.target.value;

    setValue({ target: { name: "jawabanA", value: selectedValue } });
    setjawabanA(selectedValue);

    setError({
      ...error,
      jawabanA: "",
    });
  };

  const option_cb = ["< 10 meter", ">= 10 meter"];

  const chunk_options_keys = chunk(Object.keys(option_cb), 4);

  return (
    <>
      <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <Typography margin="normal" paragraph>
              <span className={classes.badge}>{form.no}</span>
              {pertanyaan}
            </Typography>
            <div style={{ position: "absolute", right: "0", top: "58px" }}>
              <InfoButton
                title={`Pertanyaan ${form.no}`}
                content={form.definisi_operasional}
              />
            </div>
          </div>
          <div className={classes.cardBody}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  error={error.jawaban ? true : false}
                  component="fieldset"
                >
                  <RadioGroup
                    value={value.jawaban || ""}
                    onChange={handleChange}
                    aria-label="jawaban"
                    name="jawaban"
                  >
                    {form.options.map((option, index) => {
                      let disabled = false;

                      if (option === "Tidak Berlaku" && berlaku) {
                        disabled = true;
                      }
                      // else if (option !== "Tidak Berlaku" && !berlaku) {
                      //   disabled = true;
                      // }

                      return (
                        <FormControlLabel
                          disabled={disabled}
                          key={index}
                          control={<Radio />}
                          value={`${index + 1}`}
                          label={`${index + 1}. ${option}`}
                        />
                      );
                    })}
                  </RadioGroup>
                  <FormHelperText>{error.jawaban}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
        {(+jawaban === 4 ||
          +jawaban === 5 ||
          +jawaban === 6 ||
          +jawaban === 7 ||
          +jawaban === 8) && (
          <div className={classes.card}>
            <div className={classes.cardHeader}>
              <Typography margin="normal" paragraph>
                <span className={classes.badge}>21.2</span>
                <b>Jika 21.1 dijawab kode 4, 5, 6, 7, atau 8, </b>
                berapa jarak ke tempat penampungan kotoran/tinja terdekat?
              </Typography>
            </div>
            <div className={classes.cardBody}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <FormControl
                    error={error.jawabanA ? true : false}
                    component="fieldset"
                  >
                    <RadioGroup
                      className={classes.radioVertical}
                      value={jawabanA}
                      onChange={handleChangeRadio}
                      aria-label="jawabanA"
                      name="jawabanA"
                    >
                      {option_cb.map((option, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            control={<Radio />}
                            value={`${index + 1}`}
                            label={`${index + 1}. ${option}`}
                          />
                        );
                      })}
                      {/* {chunk_options_keys.map((keys_group, index) => {
                        return (
                          <div key={index} className={classes.radioSection}>
                            {keys_group.map((key) => {
                              const intKey = parseInt(key);
                              const nomor = parseInt(key) + 1;
                              return (
                                <FormControlLabel
                                  key={key}
                                  control={
                                    <Checkbox
                                      checked={isChecked(intKey + 1)}
                                      onChange={handleChangeCheckbox(
                                        intKey + 1
                                      )}
                                      value={intKey + 1}
                                    />
                                  }
                                  label={`${nomor}. ${option_cb[key]}`}
                                />
                              );
                            })}
                          </div>
                        );
                      })} */}
                    </RadioGroup>
                    <FormHelperText>{error.jawabanA}</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </form>

      <Grid item xs style={{ marginTop: 20 }}>
        <Button
          ref={backRef}
          // disabled={!isSomethingChange || isSubmitting}
          onClick={handleBackSub}
        >
          <ChevronLeft className={classes.iconLeft} /> Sebelumnya{" "}
        </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
          style={{ float: "right" }}
          ref={nextRef}
          form={id}
          disabled={isSubmitting}
          type="submit"
        >
          {subformIndex >= 31 ||
          (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")
            ? "Selanjutnya"
            : "Selanjutnya"}{" "}
          <ChevronRight className={classes.iconRight} />
        </Button>
      </Grid>
    </>
  );
}

export default SubFormNumber21New;
